export { default as AddEditPartnerForm } from './AddEditPartnerForm';
